import { defineStore } from 'pinia';
import { useLenis } from 'lenis/vue';

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        isOpen: ref(false),
    }),
    actions: {
        toggleNavigation() {
            this.isOpen = !this.isOpen;

            const lenis = useLenis() as Record<string, any>;
            if (this.isOpen === true) {
                lenis.value?.stop();
            } else {
                lenis.value?.start();
            }
        },
        closeNavigation() {
            this.isOpen = false;

            const lenis = useLenis() as Record<string, any>;
            lenis.value?.start();
        },
    },
});
